import { useRef } from "react";

/** Ref that always holds the latest value — use inside memoized DataTable column actions. */
export function useLatestRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}

export const ACCOUNT_TYPES = [
  { value: "asset", label: "Asset" },
  { value: "liability", label: "Liability" },
  { value: "equity", label: "Equity" },
  { value: "revenue", label: "Revenue" },
  { value: "expense", label: "Expense" },
];

export const EXPENSE_STATUS_META = {
  draft: { label: "Draft", color: "secondary" },
  submitted: { label: "Submitted", color: "info" },
  approved: { label: "Approved", color: "primary" },
  paid: { label: "Paid", color: "success" },
  rejected: { label: "Rejected", color: "danger" },
};

export const JOURNAL_STATUS_META = {
  draft: { label: "Draft", color: "warning" },
  posted: { label: "Posted", color: "success" },
  void: { label: "Void", color: "secondary" },
};

export const PERIOD_STATUS_META = {
  open: { label: "Open", color: "success" },
  closed: { label: "Closed", color: "secondary" },
};

export function formatAccountType(value) {
  return ACCOUNT_TYPES.find((t) => t.value === value)?.label || value;
}

export function todayIsoDate() {
  return new Date().toISOString().slice(0, 10);
}

export function monthStartIsoDate() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
}
